import './index.css'
import React from 'react'

import { useDropzone } from 'react-dropzone'
import classNames from 'classnames'
import { Box, Link, Typography } from '@mui/material'
import uploadIcon from 'assets/icons/uploadIcon.svg'
//TODO: Change the upload url and remove url
const DropZone = props => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: `text/plain,
            image/png,
            image/jpg,
            image/jpeg,
            application/pdf,
            application/msword,
            application/vnd.openxmlformats-officedocument.wordprocessingml.document,
            application/vnd.ms-excel,
            application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
    onDrop: (files) => {
      if (files.length) {
        props.onAdd(files);
      }
    }
  })

  return (
    <Box className={classNames('default-dropzone-wrapper', props.className)} color='#25245f'>
      <div className="dropzone" {...getRootProps()}>
        <input {...getInputProps()} />
        <span>
          <Typography component="span" variant='body2' color='#25245F'>Drag & Drop or</Typography>{' '}
          <Link underline="hover">
            <Typography component="span" variant="body2B" color="secondary">
              browse files
            </Typography>
          </Link>
        </span>
        <span>
          <Link>
            <img src={uploadIcon} alt="Upload Logo" style={{ marginTop: '10px' }}></img>
          </Link>
        </span>
      </div>
    </Box>
  )
}

export default DropZone
